import { actions } from './actions';
import { mutations } from './mutations';
import { getters } from './getters';
import { RootState } from '@/plugins/store';
import { Module } from 'vuex';
import { ProjetListState, state } from './state';

const module: Module<ProjetListState, RootState> = {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};
export default module;
export type { ProjetListState };
